import React from 'react';
import { NotAuthorizedNavbar } from '../../Components/Navbars';

import { Candidates } from './Candidates';
import { UserRole } from '../../Enums/UserRole';

export const CandidatesForNotAuthorized = () => {
    return (
        <>
            <NotAuthorizedNavbar />
            <Candidates role={UserRole.NotAuthorized}/>
        </>
    );
};